"use strict";
// _partialFile.js

{
  // ハンバーガーメニュー
  document.addEventListener("DOMContentLoaded", () => {
    //定義
    const drawerIcon = document.querySelector(".p-drawer__icon");
    const drawer = document.querySelector(".p-drawer");
    if (!drawerIcon || !drawer) return;

    const drawerNavItem = document.querySelectorAll('.p-drawer__body a[href^="#"]');
    const header = document.querySelector("header");
    const headerHeight = header ? header.offsetHeight : 0;
    const breakpoint = 1024; // _variables.scss の $breakpoint-drawer と合わせる
    let isMenuOpenAtBreakpoint = false;

    //メニューを開くアニメーション
    const openMenu = () => {
      if (!drawer.classList.contains("js-show")) {
        drawer.classList.add("js-show");
        drawerIcon.classList.add("js-show");
        drawerIcon.setAttribute("aria-expanded", "true");
        document.body.classList.add("js-show");
      }
    };

    //メニューを閉じるアニメーション
    const closeMenu = () => {
      if (drawer.classList.contains("js-show")) {
        drawer.classList.remove("js-show");
        drawerIcon.classList.remove("js-show");
        drawerIcon.setAttribute("aria-expanded", "false");
        document.body.classList.remove("js-show");
      }
    };

    //メニューの開閉動作
    const toggleMenu = () => {
      if (!drawer.classList.contains("js-show")) {
        openMenu();
      } else {
        closeMenu();
      }
    };

    //リサイズ処理
    const handleResize = () => {
      const bp = breakpoint;
      const windowWidth = window.innerWidth;
      if (windowWidth > bp && isMenuOpenAtBreakpoint) {
        closeMenu();
      } else if (windowWidth <= bp && drawer.classList.contains("js-show")) {
        isMenuOpenAtBreakpoint = true;
      }
    };

    //メニュー外クリック処理
    const clickOuter = (event) => {
      const isClickInsideMenu = drawer.contains(event.target) || drawerIcon.contains(event.target);

      if (drawer.classList.contains("js-show") && !isClickInsideMenu) {
        closeMenu();
      }
    };

    //該当箇所までスクロール
    const linkScroll = (target) => {
      if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = targetPosition - headerHeight;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    };

    //ヘッダーアイコン クリック時
    drawerIcon.addEventListener("click", toggleMenu);
    //画面幅リサイズ時
    window.addEventListener("resize", handleResize);
    //メニュー外クリック時
    document.addEventListener("click", clickOuter);
    //ページ内リンクナビメニュー クリック時
    drawerNavItem.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        closeMenu();
        const targetItem = document.querySelector(item.getAttribute("href"));
        linkScroll(targetItem);
      });
    });
  });
}
